import { app } from '../../app';
import { Controller } from './application-usage-report.controller';

app.component('applicationUsageReport', {
    bindings: {
        application: '<',},
    controller: Controller,
    templateUrl: require('./application-usage-report.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/application-usage-report/application-usage-report.component.js